/* eslint-disable react/prop-types */
import React, { Component } from "react";
import {
  Table, Checkbox, Grid, Form,
  Popup, Icon, Modal, Header, Button
} from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { read, write } from "xlsx";
import { topologyAction } from "../actions/changeActiveItemActions";
import Constants from "./utilities/Constants";
import Strings from "./utilities/StringSelector";
import Utils from "./utilities/Utils";

const ipRegex = new RegExp("^[0-2][0-9.]*$");
const nameRegex = new RegExp("^[A-Za-z][A-Za-z-]*");

const UtilsInstance = new Utils();
var cameFromHomepageListClick = false;

class NetworkTraffic extends Component {

  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      formInput: "",
      uptime: "",
      originalInfo: [],
      info: [],
      isErrorDevicesToggleChecked: false,
      isIntelligentFilterToggleChecked: false,
      isFirstFilterRetrieve: true,
      measurementUptime: "",
      isModalOpen: false,
      turnText: Strings.TURN_ON
    };

    cameFromHomepageListClick = false;
  }

  /*
    Decides whether or not to filter the list based on devices that have
    at least one input or one exit error at any of their ports
  */
  toggleErrorDevicesCheckbox = () => {
    // If the toggle is not checked there is something written on the form
    if (this.state.isErrorDevicesToggleChecked === false && this.state.formInput !== "") {
      // Clear the form before toggling the checkbox
      document.getElementById("inputform").value = "";
      this.setState({ formInput: "" }, () => {
        this.setState({ info: this.state.originalInfo });
      });
    }
    // Now toggle the checkbox
    cameFromHomepageListClick = false;
    const toggled = !this.state.isErrorDevicesToggleChecked;
    this.setState({ isErrorDevicesToggleChecked: toggled }, () => {
      const infoLen = this.state.originalInfo.length;
      const searchedDevices = [];

      if (this.state.isErrorDevicesToggleChecked) {
        // Show only Devices that have at least one input or one exit error on any port
        for (let i = 0; i < infoLen; i++) {
          if (this.hasDeviceAnyErrors(this.state.originalInfo[i])) {
            searchedDevices.push(this.state.originalInfo[i]);
          }
        }
        if (searchedDevices.length > 0) {
          this.setState({ info: searchedDevices });
        } else {
          this.setState({ info: [] });
        }
      } else {
        // Show all Devices
        this.setState({ info: this.state.originalInfo });
      }
    });
  }

  toggleIntelligentFilterCheckbox = () => {
    if (this.state.isIntelligentFilterToggleChecked) {
      this.setState({ turnText: Strings.TURN_OFF }, () => this.showModal());
    }
    else {
      this.setState({ turnText: Strings.TURN_ON }, () => this.showModal());
    }
  }

  alterFilterTraffic = () => {
    fetch(Constants.REQUEST_IP_ADDRESS + "filterTraffic_POST", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: JSON.stringify({ filter: !this.state.isIntelligentFilterToggleChecked })
    })
      .then(UtilsInstance.checkStatus)
      .then(() => {
        this.setState({
          isIntelligentFilterToggleChecked: !this.state.isIntelligentFilterToggleChecked,
          isFirstFilterRetrieve: true, // let the filter be refreshed once more
        }, () => {
          // refresh the data right after turning the filter on/off
          this.retrieveData();
        });
      })
      .catch((error) => {
        if (this.state.isIntelligentFilterToggleChecked) {
          alert(Strings.PORTS_FILTER_TURN_ON_FAILURE + "\n" + Strings.REASON_DP + error);
        }
        else {
          alert(Strings.PORTS_FILTER_TURN_OFF_FAILURE + "\n" + Strings.REASON_DP + error);
        }
      })
      .finally(() => {
        this.closeModal();
      });
  }

  // Returns true if the device has any input or exit errors or false otherwise
  hasDeviceAnyErrors = (device) => {
    let hasErrors = false;
    const portsLen = device.ports.length;
    for (let i = 0; i < portsLen; i++) {
      if (device.ports[i].exitErrors > 0 || device.ports[i].inputErrors > 0) {
        hasErrors = true;
        break;
      }
    }
    return hasErrors;
  }

  // Creates a list with entries that match the IP passed on the form
  handleIPSearch = () => {
    const len = this.state.originalInfo.length;
    const searchedDevices = [];

    for (let i = 0; i < len; i++) {
      if (this.state.originalInfo[i].ip === this.state.formInput) {
        searchedDevices.push(this.state.originalInfo[i]);
      }
    }
    // Show all devices that matched the IP on the form or none
    if (searchedDevices.length > 0) {
      this.setState({ info: searchedDevices });
    } else {
      this.setState({ info: [] });
    }
  }

  handleMultipleIPSearch = () => {
    if (this.props.location.state !== undefined) {
      if (this.props.location.state.deviceIpList !== undefined) {
        cameFromHomepageListClick = true;
        const ipLen = this.props.location.state.deviceIpList.length;
        const infoLen = this.state.originalInfo.length;
        const searchedDevices = [];
        const alreadyAddedIps = [];

        for (let i = 0; i < ipLen; i++) {
          for (let j = 0; j < infoLen; j++) {
            if (this.state.originalInfo[j].ip === this.props.location.state.deviceIpList[i]) {
              if (!alreadyAddedIps.includes(this.props.location.state.deviceIpList[i])) {
                searchedDevices.push(this.state.originalInfo[j]);
                alreadyAddedIps.push(this.props.location.state.deviceIpList[i]);
              }
            }
          }
        }
        // Show all devices that matched the IP on the form or none
        if (searchedDevices.length > 0) {
          this.setState({ info: searchedDevices });
        } else {
          this.setState({ info: [] });
        }
      }
    }
  }

  // Creates a list with entries that match the name passed on the form
  handleNameSearch = () => {
    const len = this.state.originalInfo.length;
    const searchedDevices = [];

    for (let i = 0; i < len; i++) {
      // Uppercases both strings before comparison to allow search flexibility
      // Also remove all whitespaces in both strings before comparing
      if (this.state.originalInfo[i].name != null && this.state.formInput != null) {

        let noWhitespaceUppercasedDeviceName = this.state.originalInfo[i].name.toUpperCase().replace(/\s/g, "");
        let noWhitespaceUppercasedFormInput = this.state.formInput.toUpperCase().replace(/\s/g, "");

        if (noWhitespaceUppercasedDeviceName.indexOf(noWhitespaceUppercasedFormInput) !== -1) {
          searchedDevices.push(this.state.originalInfo[i]);
        }
      }
    }
    // Show all devices that matched the name on the form or none
    if (searchedDevices.length > 0) {
      this.setState({ info: searchedDevices });
    } else {
      this.setState({ info: [] });
    }
  }

  /*
    Handles user form submit 
    Filters the page list showing only the devices that match the
    ip or name the user has typed
  */
  handleSubmit = () => {
    cameFromHomepageListClick = false;
    // If the input is not an empty string
    if (this.state.formInput !== "") {
      // If the toggle is checked, uncheck it
      if (this.state.isErrorDevicesToggleChecked) {
        this.toggleErrorDevicesCheckbox();
      }
      // Then check if what was typed is similar to an IP or a Device name
      if (ipRegex.test(this.state.formInput)) {
        this.handleIPSearch();
      }
      else if (nameRegex.test(this.state.formInput)) {
        this.handleNameSearch();
      }
    }
    else if (this.state.formInput === "") {
      this.setState({ info: this.state.originalInfo });
    }
  }

  retrieveData = async () => {
    // Only retrieve data if the form is empty, the errors toggle is not checked and the page was not
    // requested from the click on one of the traffic errors items in the homepage
    if (this.state.formInput === "" && !this.state.isErrorDevicesToggleChecked && !cameFromHomepageListClick) {

      // Only get the filter state when this variable is true
      if (this.state.isFirstFilterRetrieve) {
        let promissesArray = [];

        // Retrieve devices list
        promissesArray.push(
          fetch(Constants.REQUEST_IP_ADDRESS + "traffic", { mode: "cors" })
            .then(res => res.json())
            .then(data => data)
        );

        // Retrieve the intelligent filter state
        promissesArray.push(
          fetch(Constants.REQUEST_IP_ADDRESS + "filterTrafficState", { mode: "cors" })
            .then(res => res.json())
            .then(data => data)
        );

        let resolvedPromisses = await Promise.all(promissesArray);

        let measurementUptime = this.formatToRelativeTime(resolvedPromisses[0].uptime);

        let traffic = resolvedPromisses[0].devices.sort((a, b) => {
          const num1 = Number(a.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
          const num2 = Number(b.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
          return num1 - num2;
        });

        let trafficStateFilter = resolvedPromisses[1];

        this.setState({
          measurementUptime: measurementUptime,
          info: traffic,
          originalInfo: traffic,
          isIntelligentFilterToggleChecked: trafficStateFilter.filter,
          isFirstFilterRetrieve: false
        }, () => {
          this.handleMultipleIPSearch();
        });
      }
      else {
        let promissesArray = [];

        promissesArray.push(
          fetch(Constants.REQUEST_IP_ADDRESS + "traffic", { mode: "cors" })
            .then(res => res.json())
            .then(data => data)
        );

        let resolvedPromisses = await Promise.all(promissesArray);

        let measurementUptime = this.formatToRelativeTime(resolvedPromisses[0].uptime);

        let traffic = resolvedPromisses[0].devices.sort((a, b) => {
          const num1 = Number(a.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
          const num2 = Number(b.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
          return num1 - num2;
        });

        this.setState({
          measurementUptime: measurementUptime,
          info: traffic,
          originalInfo: traffic
        }, () => {
          this.handleMultipleIPSearch();
        });
      }
    }
  }

  parseFloatTo2DecimalPlaces = (floatInput) => {
    // If the floatInput is not 'None' return the number trimmed to 2 decimal places
    if (floatInput !== Constants.NONE) {
      return parseFloat(floatInput).toFixed(2);
    }
    else {
      return floatInput;
    }
  }

  /*
    Adjusts the size of the table so that it does not excced the
    browser window height limit
  */
  adjustTableMaxHeight = () => {
    const browserHeight = UtilsInstance.getBrowserWindowHeight();
    let newTableMaxHeight = browserHeight * 0.65;
    newTableMaxHeight = newTableMaxHeight.toString();
    newTableMaxHeight = newTableMaxHeight.concat("px");
    document.getElementById("main-table-container").style["maxHeight"] = newTableMaxHeight;
  }

  /*
    Saves the form input to the component state everytime the user
    types something in the form
  */
  handleChange = (e, { name, value }) => this.setState({ [name]: value })

  createErrorsTableCell = (errors, increment, deviceIP, topologyPortName) => {
    if (errors === "") {
      return <Table.Cell verticalAlign="middle">{Strings.NO_ANSWER}</Table.Cell>;
    }
    else {
      if (increment > 0) {
        return (
          <Table.Cell style={errorsTableCellStyle}
            selectable
            verticalAlign="middle"
            onClick={() => { this.handleErrorsTableCellClick(deviceIP, topologyPortName); }}>
            <span style={warningBadgeStyle}>{errors}</span>
          </Table.Cell>
        );
      }
      else {
        return <Table.Cell verticalAlign="middle">{errors}</Table.Cell>;
      }
    }
  }

  handleErrorsTableCellClick = (ip, topologyPortName) => {
    this.props.onChangeTopology();
    this.props.history.push({
      pathname: "/topology",
      state: {
        deviceIP: ip,
        portName: topologyPortName
      }
    });
  }

  getDaysInMonth = (month, year) => {
    if (typeof year == "undefined") year = 1999; // any non-leap-year works as default     
    let currmon = new Date(year, month),
      nextmon = new Date(year, month + 1);
    return Math.floor((nextmon.getTime() - currmon.getTime()) / (24 * 3600 * 1000));
  }

  getDateTimeSince = (target) => { // target should be a Date object
    let now = new Date(), yd, md, dd, hd, nd, sd, out = [];

    yd = now.getFullYear() - target.getFullYear();
    md = now.getMonth() - target.getMonth();
    dd = now.getDate() - target.getDate();
    hd = now.getHours() - target.getHours();
    nd = now.getMinutes() - target.getMinutes();
    sd = now.getSeconds() - target.getSeconds();

    if (md < 0) { yd--; md += 12; }
    if (dd < 0) {
      md--;
      dd += this.getDaysInMonth(now.getMonth() - 1, now.getFullYear());
    }
    if (hd < 0) { dd--; hd += 24; }
    if (nd < 0) { hd--; nd += 60; }
    if (sd < 0) { nd--; sd += 60; }

    if (yd > 0) out.push(yd + Strings.YEAR + (yd === 1 ? "" : "s"));
    if (md > 0) {
      if (md === 1) {
        out.push(md + Strings.MONTH);
      }
      else {
        out.push(md + Strings.MONTHS);
      }
    }
    if (dd > 0) out.push(dd + Strings.DAY + (dd === 1 ? "" : "s"));
    if (hd > 0) out.push(hd + Strings.HOUR + (hd === 1 ? "" : "s"));
    if (nd > 0) out.push(nd + Strings.MINUTE + (nd === 1 ? "" : "s"));
    if (sd > 0) out.push(sd + Strings.SECOND + (sd === 1 ? "" : "s"));
    return out.join(" ");
  }

  formatToRelativeTime = (uptimeInSeconds) => {
    if (uptimeInSeconds !== undefined) {
      const uptimeInMillis = uptimeInSeconds * 1000;
      const timeNow = new Date().getTime();
      const whenWasTurnedOn = timeNow - uptimeInMillis;
      const dateWhenWasTurnedOn = new Date(whenWasTurnedOn);
      return this.getDateTimeSince(new Date(dateWhenWasTurnedOn));
    }
  }

  /*
    The measurement time that is retrieved from the database comes as a string.
    We had a problem that the time that was being retrieved was not correct. 
    The workarround we found for this was to remove the last two characters of 
    the string and it miraculously it was in the format we nedded 
  */
  formatUptimeStringToRelativeTime = (uptimeInSeconds) => {
    if (uptimeInSeconds !== undefined && uptimeInSeconds !== "None" && uptimeInSeconds !== "") {
      let uptimeSubstring = uptimeInSeconds.substring(0, uptimeInSeconds.length - 2);
      let uptimeSubstringNumber = parseInt(uptimeSubstring);
      const uptimeInMillis = uptimeSubstringNumber * 1000;
      const timeNow = new Date().getTime();
      const whenWasTurnedOn = timeNow - uptimeInMillis;
      const dateWhenWasTurnedOn = new Date(whenWasTurnedOn);
      return this.getDateTimeSince(new Date(dateWhenWasTurnedOn));
    }
    else if (uptimeInSeconds === "None" || uptimeInSeconds === "") {
      return Strings.NO_ANSWER;
    }
  }

  showModal = () => this.setState({ isModalOpen: true })

  closeModal = () => this.setState({ isModalOpen: false })

  handleModalCancelClick = () => {
    this.closeModal();
  }

  handleModalOkClick = () => {
    this.alterFilterTraffic();
  }

  getMAUTypeCell = (MAUType) => {
    if (MAUType === null) {
      return (
        <Table.Cell verticalAlign="middle">{Strings.NO_ANSWER}</Table.Cell>
      );
    }
    else if (MAUType === "") {
      return (
        <Table.Cell verticalAlign="middle">{Strings.NO_ANSWER}</Table.Cell>
      );
    }
    else if (MAUType.toUpperCase() === Constants.UNKNOWN_UPPERCASE) {
      return (
        <Table.Cell verticalAlign="middle">{Strings.NO_ANSWER}</Table.Cell>
      );
    }
    else {
      return (
        <Table.Cell verticalAlign="middle">{MAUType}</Table.Cell>
      );
    }
  }

  getLineDelayValueCell = (lineDelayValue) => {
    if (lineDelayValue === null) {
      return <Table.Cell verticalAlign="middle">{Strings.NO_ANSWER}</Table.Cell>;
    }
    else if (lineDelayValue === "") {
      return <Table.Cell verticalAlign="middle">{Strings.NO_ANSWER}</Table.Cell>;
    }
    else if (lineDelayValue.toUpperCase() === "UNKNOWN") {
      return <Table.Cell verticalAlign="middle">{Strings.NO_ANSWER}</Table.Cell>;
    }
    else {
      if (lineDelayValue.toUpperCase().includes("IN NANOSECONDS")) {
        // Como o texto vai estar neste formato: Cable delay in nanoseconds (264)
        // vamos pegar apenas o valor numérico do delay entre parênteses usando expressões regulares
        const delayValueRegex = /\((\d+)\)/;
        const delayMatch = lineDelayValue.match(delayValueRegex);
        const delayValue = Number(delayMatch[1]);

        if (delayMatch) {
          if (lineDelayValue.toUpperCase().includes("CABLE")) {
            if (delayValue > 528) {
              return (
                <Table.Cell
                  style={errorsTableCellStyle}
                  verticalAlign="middle">
                  {Strings.CABLE_DELAY}: {delayValue} ns
                </Table.Cell>
              );
            }
            else {
              return (
                <Table.Cell
                  verticalAlign="middle">
                  {Strings.CABLE_DELAY}: {delayValue} ns
                </Table.Cell>
              );
            }
          }
          else {
            if (delayValue > 528) {
              return (
                <Table.Cell
                  style={errorsTableCellStyle}
                  verticalAlign="middle">
                  {Strings.LINE_DELAY}: {delayValue} ns
                </Table.Cell>
              );
            }
            else {
              return (
                <Table.Cell
                  verticalAlign="middle">
                  {Strings.LINE_DELAY}: {delayValue} ns
                </Table.Cell>
              );
            }
          }
        }
        else {
          return <Table.Cell verticalAlign="middle">{lineDelayValue}</Table.Cell>;
        }
      }
      else {
        // Esse split serve para pegar o valor do delay
        // Ex: Cable delay: 234 -> ['Cable delay ',' 234']
        // Ex: Line delay: 234 -> ['Line delay ',' 234']
        let splittedLineDelay = lineDelayValue.split(":");
        // Se houver ao menos dois elementos no array após o split, é por que deu certo
        if (splittedLineDelay.length > 1) {
          // Pegue o valor do delay (que está no índice 1), retire os espaços em branco e transforme em número
          const delayText = lineDelayValue.split(":")[0].trim();
          const delayValue = Number(lineDelayValue.split(":")[1].trim());
          // Se o delay for maior que 528, pinte a célula de laranja
          if (delayValue > 528) {
            return (
              <Table.Cell
                style={errorsTableCellStyle}
                verticalAlign="middle">
                {delayText}: {delayValue} ns
              </Table.Cell>
            );
          }
          else {
            return (
              <Table.Cell
                verticalAlign="middle">
                {delayText}: {delayValue} ns
              </Table.Cell>
            );
          }
        }
        // Se não houver dois elementos após o split, o valor de delay veio em um formato não padrão
        // Então apenas mostre na tela o texto, sem nenhum pré-processamento
        else {
          return <Table.Cell verticalAlign="middle">{lineDelayValue}</Table.Cell>;
        }
      }
    }
  }

  getSpeedCell = (interface_speed) => {
    if (interface_speed !== "") {
      return <Table.Cell verticalAlign="middle">{interface_speed} Mbps</Table.Cell>;
    }
    else {
      return <Table.Cell verticalAlign="middle">{Strings.NO_ANSWER}</Table.Cell>;
    }
  }

  getLinkStateLinkCell = (linkStateLink) => {
    let label = Strings.NO_ANSWER;
    let style = portStatusBadgeStyle.unknown;

    if (linkStateLink === "up") {
      label = Strings.ACTIVE;
      style = portStatusBadgeStyle.active;
    }
    else if (linkStateLink === "down") {
      label = Strings.INACTIVE;
      style = portStatusBadgeStyle.inactive;
    }

    return (
      <Table.Cell verticalAlign="middle" style={statusTableCellStyle}>
        <span style={style}>{label}</span>
      </Table.Cell>
    );
  }

  getTrafficSpeedKbpsCell = (kbps) => {
    if (kbps === null) {
      return <Table.Cell verticalAlign="middle">{Strings.NO_ANSWER}</Table.Cell>;
    }
    else if (kbps === "") {
      return <Table.Cell verticalAlign="middle">{Strings.NO_ANSWER}</Table.Cell>;
    }
    else {
      return (
        <Table.Cell verticalAlign="middle">
          {this.parseFloatTo2DecimalPlaces(kbps).toString().replace(".", ",")}
        </Table.Cell>
      );
    }
  }

  getNameTextForCSV = (value) => {
    if (value === undefined || value === null || value === "") {
      return Strings.NO_ANSWER;
    }

    const text = String(value);
    const normalized = text.toUpperCase();
    if (normalized === "NONE" || normalized === "UNKNOWN") {
      return Strings.NO_ANSWER;
    }

    return text.replace(/,/g, " ");
  };

  getSpeedTextForCSV = (interfaceSpeed) => {
    if (interfaceSpeed === undefined || interfaceSpeed === null || interfaceSpeed === "") {
      return Strings.NO_ANSWER;
    }
    return `${interfaceSpeed} Mbps`;
  };

  getLineDelayValueForCSV = (lineDelayValue) => {
    if (lineDelayValue === undefined || lineDelayValue === null || lineDelayValue === "") {
      return Strings.NO_ANSWER;
    }

    const text = String(lineDelayValue);
    if (text.toUpperCase() === "UNKNOWN") {
      return Strings.NO_ANSWER;
    }

    if (text.toUpperCase().includes("IN NANOSECONDS")) {
      const delayMatch = text.match(/\((\d+)\)/);
      if (!delayMatch) return text;
      const delayValue = Number(delayMatch[1]);
      return text.toUpperCase().includes("CABLE")
        ? `${Strings.CABLE_DELAY}: ${delayValue} ns`
        : `${Strings.LINE_DELAY}: ${delayValue} ns`;
    }

    const splitDelay = text.split(":");
    if (splitDelay.length > 1) {
      const delayText = splitDelay[0].trim();
      const delayValue = Number(splitDelay[1].trim());
      if (!Number.isNaN(delayValue)) return `${delayText}: ${delayValue} ns`;
    }

    return text;
  };

  getTrafficSpeedForCSV = (kbps) => {
    if (kbps === undefined || kbps === null || kbps === "") {
      return Strings.NO_ANSWER;
    }
    return this.parseFloatTo2DecimalPlaces(kbps).toString();
  };

  getLinkStateLinkForCSV = (linkStateLink) => {
    if (linkStateLink === "up") return Strings.ACTIVE;
    if (linkStateLink === "down") return Strings.INACTIVE;
    return Strings.NO_ANSWER;
  };

  exportTrafficAsCSV = () => {
    let csvText = Strings.TRAFFIC_CSV_HEADER;

    this.state.originalInfo.forEach((device) => {
      const ports = Array.isArray(device.ports) ? device.ports : [];
      if (ports.length === 0) {
        csvText += this.getNameTextForCSV(device.ip) + ","
          + this.getNameTextForCSV(device.name) + ","
          + this.formatUptimeStringToRelativeTime(device.uptime) + ","
          + ",,,,,,,,\n";
        return;
      }

      ports.forEach((port) => {
        csvText += this.getNameTextForCSV(device.ip) + ","
          + this.getNameTextForCSV(device.name) + ","
          + this.formatUptimeStringToRelativeTime(device.uptime) + ","
          + this.getNameTextForCSV(port.name) + ","
          + this.getNameTextForCSV(port.MAUType) + ","
          + this.getLineDelayValueForCSV(port.lineDelayValue) + ","
          + this.getSpeedTextForCSV(port.speed) + ","
          + this.getTrafficSpeedForCSV(port.inputKbps) + ","
          + this.getNameTextForCSV(port.inputErrors) + ","
          + this.getTrafficSpeedForCSV(port.exitKbps) + ","
          + this.getNameTextForCSV(port.exitErrors) + ","
          + this.getLinkStateLinkForCSV(port.linkStateLink) + "\n";
      });
    });

    const workbook = read(csvText, { type: "string", raw: true });
    const wbout = write(workbook, { bookType: "xlsx", type: "binary" });
    const blob = new Blob([UtilsInstance.s2ab(wbout)], { type: "application/octet-stream" });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = Strings.TRAFFIC_CSV_EXPORT_NAME;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    sessionStorage.removeItem("auth");
    this.retrieveData();
    // store intervalId in the state so it can be accessed later
    this.setState({ intervalID: setInterval(this.retrieveData, 5000) });
    this.adjustTableMaxHeight();
  }

  componentWillUnmount() {
    clearInterval(this.state.intervalID);
  }

  componentDidUpdate() {
    this.adjustTableMaxHeight();
  }

  // Render the table containing the network traffic
  render() {
    const filter = this.state.formInput;

    const trafficDevices = this.state.info.map(device => (
      <React.Fragment key={device.ip}>
        <Table.Row style={mainTableRowStyle} >
          <Table.Cell verticalAlign="middle">{device.ip}</Table.Cell>
          <Table.Cell verticalAlign="middle">{UtilsInstance.getDeviceName(device.name, Strings, UtilsInstance)}</Table.Cell>
          <Table.Cell verticalAlign="middle">{this.formatUptimeStringToRelativeTime(device.uptime)}</Table.Cell>
          <Table.Cell colSpan="8" />
        </Table.Row>
        {
          device.ports.map(port => (
            <Table.Row key={port.name}>
              <Table.Cell colSpan="3" verticalAlign="middle">{port.name}</Table.Cell>
              {this.getMAUTypeCell(port.MAUType)}
              {this.getLineDelayValueCell(port.lineDelayValue)}
              {this.getSpeedCell(port.speed)}
              {this.getTrafficSpeedKbpsCell(port.inputKbps)}
              {this.createErrorsTableCell(port.inputErrors, port.inputErrorsIncrement, device.ip, port.topologyName)}
              {this.getTrafficSpeedKbpsCell(port.exitKbps)}
              {this.createErrorsTableCell(port.exitErrors, port.exitErrorsIncrement, device.ip, port.topologyName)}
              {this.getLinkStateLinkCell(port.linkStateLink)}
            </Table.Row>
          ))
        }
      </React.Fragment>
    ));

    return (
      <div style={screenStyle}>
        <Grid className="ts-page-toolbar ts-traffic-toolbar" columns={4} doubling stackable verticalAlign="middle">
          <Grid.Row>

            <Grid.Column width={4}>
              <p><b>{Strings.MEASUREMENT_INTERVAL}:</b> {this.state.measurementUptime}</p>
            </Grid.Column>

            <Grid.Column width={7}>
              <Form className="ts-toolbar-search" style={searchStyle} onSubmit={this.handleSubmit} >
                <Form.Input
                  id="inputform"
                  placeholder={Strings.TRAFFIC_INPUT_TEXT_PLACEHOLDER}
                  icon="search"
                  name="formInput"
                  value={filter}
                  onChange={this.handleChange} />
              </Form>
            </Grid.Column>

            <Grid.Column width={3}>
              <Form style={{ display: "flex", justifyContent: "center" }}>
                <Form.Group grouped>
                  <Form.Field>
                    <Checkbox
                      style={checkboxStyle}
                      fitted
                      toggle
                      label={
                        <label>
                          {Strings.PORTS_FILTER_LABEL}
                          <Popup
                            wide
                            position='bottom right'
                            trigger={<Icon name="question circle" color="teal" style={questionIconStyle} />}>
                            <Popup.Content>
                              <p>{Strings.PORTS_FILTER_POPUP_1}</p>
                              <p>{Strings.PORTS_FILTER_POPUP_2}</p>
                            </Popup.Content>
                          </Popup>
                        </label>
                      }
                      onChange={this.toggleIntelligentFilterCheckbox}
                      checked={this.state.isIntelligentFilterToggleChecked} />
                  </Form.Field>
                  <Form.Field>
                    <Checkbox
                      style={checkboxStyle}
                      fitted
                      toggle
                      label={Strings.SHOW_ONLY_ERROR_DEVICES}
                      onChange={this.toggleErrorDevicesCheckbox}
                      checked={this.state.isErrorDevicesToggleChecked} />
                  </Form.Field>
                </Form.Group>
              </Form>
            </Grid.Column>

            <Grid.Column width={2} textAlign="right">
              <Button
                content={Strings.EXPORT_CSV}
                color="teal"
                onClick={this.exportTrafficAsCSV} />
            </Grid.Column>
          </Grid.Row>
        </Grid>

        <Table id="table-header" style={headerMarginStyle} compact stackable fixed structured celled textAlign="center">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell rowSpan="2">{Strings.IP}</Table.HeaderCell>
              <Table.HeaderCell rowSpan="2">{Strings.NAME}</Table.HeaderCell>
              <Table.HeaderCell rowSpan="2">{Strings.TIME}<br />{Strings.TURNED_ON_1}</Table.HeaderCell>
              <Popup position='bottom center' hoverable pinned
                trigger={
                  <Table.HeaderCell rowSpan="2">
                    {Strings.DUPLEX_MODE_1}<Icon name="question circle" color="teal" style={questionIconStyle} /> <br />
                    {Strings.DUPLEX_MODE_2}
                  </Table.HeaderCell>
                }>
                <Popup.Content>
                  <p>{Strings.DUPLEX_MODE_POPUP}</p>
                </Popup.Content>
              </Popup>
              <Popup position='bottom center' hoverable pinned wide="very"
                trigger={
                  <Table.HeaderCell rowSpan="2">
                    {Strings.LINE_DELAY_VALUE_1}<Icon name="question circle" color="teal" style={questionIconStyle} />
                  </Table.HeaderCell>
                }>
                <Popup.Content>
                  <p>{Strings.DELAY_POPUP_1}</p>
                  <p>{Strings.DELAY_POPUP_2}</p>
                  <p>{Strings.DELAY_POPUP_3}</p>
                  <p>{Strings.DELAY_POPUP_4}</p>
                  <ul>
                    <li>
                      <b>{Strings.CABLE_DELAY}</b>: {Strings.DELAY_POPUP_5}
                    </li>
                    <li>
                      <b>{Strings.LINE_DELAY}</b>: {Strings.DELAY_POPUP_6}
                    </li>
                  </ul>
                </Popup.Content>
              </Popup>
              <Table.HeaderCell rowSpan="2">{Strings.INTERFACE_SPEED_1}<br />{Strings.INTERFACE_SPEED_2}</Table.HeaderCell>
              <Table.HeaderCell colSpan="2">{Strings.IN_PACKETS}</Table.HeaderCell>
              <Table.HeaderCell colSpan="2">{Strings.OUT_PACKETS}</Table.HeaderCell>
              <Table.HeaderCell rowSpan="2">{Strings.PORT_STATUS}</Table.HeaderCell>
            </Table.Row>
            <Table.Row>
              <Table.HeaderCell>{Strings.DROPDOWN_TRAFFIC} (Kbps)</Table.HeaderCell>
              <Popup position='left center' hoverable pinned wide="very"
                trigger={
                  <Table.HeaderCell>
                    {Strings.DROPDOWN_ERRORS}<Icon name="question circle" color="teal" style={questionIconStyle} />
                  </Table.HeaderCell>
                }>
                <Popup.Content>
                  <Header as="h4" style={headerStyle}>{Strings.DELTA_ERRORS_SUGGESTION_2}</Header>
                  <p>{Strings.IN_ERRORS_POPUP}</p>
                  <ul>
                    <li>{Strings.DELTA_ERRORS_SUGGESTION_3}</li>
                    <li>{Strings.DELTA_ERRORS_SUGGESTION_4}</li>
                    <li>{Strings.DELTA_ERRORS_SUGGESTION_5}</li>
                    <li>{Strings.DELTA_ERRORS_SUGGESTION_6}</li>
                  </ul>
                </Popup.Content>
              </Popup>
              <Table.HeaderCell>{Strings.DROPDOWN_TRAFFIC} (Kbps)</Table.HeaderCell>
              <Popup position='left center' hoverable pinned wide="very"
                trigger={
                  <Table.HeaderCell>
                    {Strings.DROPDOWN_ERRORS}<Icon name="question circle" color="teal" style={questionIconStyle} />
                  </Table.HeaderCell>
                }>
                <Popup.Content>
                  <Header as="h4" style={headerStyle}>{Strings.DELTA_ERRORS_SUGGESTION_7}</Header>
                  <p>{Strings.OUT_ERRORS_POPUP}</p>
                  <ul>
                    <li>{Strings.DELTA_ERRORS_SUGGESTION_8}</li>
                    <li>{Strings.DELTA_ERRORS_SUGGESTION_9}</li>
                    <li>{Strings.DELTA_ERRORS_SUGGESTION_10}</li>
                  </ul>
                </Popup.Content>
              </Popup>
            </Table.Row>
          </Table.Header>
        </Table>
        <div id="main-table-container" style={tableStyle}>
          <Table id="main-table" style={tableBorderStyle} compact stackable fixed structured celled textAlign="center">
            <Table.Body>
              {trafficDevices}
            </Table.Body>
          </Table>
        </div>

        <Modal style={modalStyle} centered open={this.state.isModalOpen} onClose={this.closeModal} size='small'>
          <Header icon='warning sign' content={Strings.ARE_YOU_SURE_YOU_WANT + this.state.turnText + Strings.THE_PORTS_FILTER} />
          <Modal.Content>
            <p>{Strings.PORTS_FILTER_POPUP_1}</p>
            <p>{Strings.PORTS_FILTER_POPUP_2}</p>
          </Modal.Content>
          <Modal.Actions>
            <Button color='red' onClick={this.handleModalCancelClick}>
              <Icon name='remove' />{Strings.NO}
            </Button>
            <Button color='green' onClick={this.handleModalOkClick}>
              <Icon name='checkmark' />{Strings.YES}
            </Button>
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}

// CSS custom table stylization
const screenStyle = {
  marginTop: "8px",
  marginLeft: "4px",
  marginRight: "4px",
  textAlign: "center"
};

const tableStyle = {
  overflowY: "scroll",
};

const tableBorderStyle = {
  borderCollapse: "separate"
};

const headerMarginStyle = {
  marginTop: "16px",
  marginBottom: "8px",
  width: "99%",
  borderCollapse: "separate"
};

const mainTableRowStyle = {
  backgroundColor: "rgba(0, 0, 50, 0.04)"
};

const checkboxStyle = {
  marginTop: "0px"
};

const searchStyle = {
  width: "100%"
};

const errorsTableCellStyle = {
  backgroundColor: "transparent"
};

const warningBadgeStyle = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  minWidth: "58px",
  padding: "5px 10px",
  borderRadius: "999px",
  color: "black",
  backgroundColor: "#ff6600",
  border: "1px solid #ff6600",
  fontSize: "12px",
  fontWeight: 700,
  lineHeight: "16px"
};


const portStatusBadgeBaseStyle = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  minWidth: "76px",
  padding: "5px 10px",
  borderRadius: "999px",
  color: "black",
  fontSize: "12px",
  fontWeight: 700,
  lineHeight: "16px",
  border: "1px solid transparent"
};

const statusTableCellStyle = {
  backgroundColor: "transparent"
};

const portStatusBadgeStyle = {
  active: {
    ...portStatusBadgeBaseStyle,
    backgroundColor: "lime",
    borderColor: "lime"
  },
  inactive: {
    ...portStatusBadgeBaseStyle,
    backgroundColor: "#dcdcdc",
    borderColor: "#dcdcdc"
  },
  unknown: {
    ...portStatusBadgeBaseStyle,
    backgroundColor: "#dcdcdc",
    borderColor: "#dcdcdc"
  }
};

const mapActionsToProps = {
  onChangeTopology: topologyAction
};

const questionIconStyle = {
  marginLeft: "4px"
};

const modalStyle = {
  marginLeft: "auto",
  marginRight: "auto",
  marginTop: "30vh",
  height: "275px"
};


const headerStyle = {
  marginTop: "8px",
  marginBottom: "8px",
};

export default connect(null, mapActionsToProps)(withRouter(NetworkTraffic));